module.exports = __webpack_public_path__ + "img/10.f50ec8b8.jpg";